import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import { PONCTUEL_PROGRAMMED } from '../services/rachat-allocation';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    const options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        rachatPartielType: [
          entity?.parameters?.rachatPartielType || null,
          [Validators.required],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products.map((product, index) => {
      if (product.parameters?.rachatPartielType === PONCTUEL_PROGRAMMED) {
        return product;
      }

      const original = this.entity?.products?.[index]?.parameters;
      return {
        ...product,
        parameters: {
          ...product.parameters,
          totalDivestmentAmountProgrammed: null,
          rppStartDate: null,
          rppEndDate: null,
          supportsDivestmentProgrammed: (
            original?.supportsDivestmentProgrammed || []
          ).map(support => ({
            ...support,
            disinvest: 0,
            amountDisinvest: 0,
          })),
        },
      };
    });
  }
}
